// extracted by mini-css-extract-plugin
module.exports = {"inner":"styles_inner__JENhw","errorLogs":"styles_errorLogs__2g01N"};